// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.footer_footer__NjMd5 {
  font-size: 12px;
  color: gray;
  text-align: center;
  background-color: var(--backgroundColor);
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.footer_langButton__TnGDQ {
  all: unset;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 6px;
}

.footer_lang__FMjCi {
  display: flex;
  gap: 8px;
}
.footer_lang__FMjCi .footer_langButton__TnGDQ {
  all: unset;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  background-color: transparent;
  border: 1px solid #888;
  transition: 0.3s;
}
.footer_lang__FMjCi .footer_langButton__TnGDQ:hover {
  background-color: rgba(240, 240, 240, 0.2274509804);
}
.footer_lang__FMjCi .footer_langButton__TnGDQ.footer_active__k3EW8 {
  background-color: var(--accentColor);
  color: var(--textOnAcccentColor);
}

.footer_link__DsQ78 {
  color: var(--textColor);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/components/footer/footer.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AAXA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAcF;;AAXA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAcF;;AAXA;EACE,aAAA;EACA,QAAA;AAcF;AAZE;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;AAcJ;AAZI;EACE,mDAAA;AAcN;AAXI;EACE,oCAAA;EACA,gCAAA;AAaN;;AAPA;EACE,uBAAA;EACA,gBAAA;AAUF","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import '../../styles/vars.scss';\n\n.footer {\n  font-size: 12px;\n  color: gray;\n  text-align: center;\n  background-color: var(--backgroundColor);\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.langButton {\n  all: unset;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 6px;\n}\n\n.lang {\n  display: flex;\n  gap: 8px;\n\n  .langButton {\n    all: unset;\n    cursor: pointer;\n    padding: 6px 10px;\n    border-radius: 6px;\n    background-color: transparent;\n    border: 1px solid #888;\n    transition: 0.3s;\n\n    &:hover {\n      background-color: #f0f0f03a;\n    }\n\n    &.active {\n      background-color: var(--accentColor);\n      color: var(--textOnAcccentColor);\n    }\n  }\n\n}\n\n.link {\n  color: var(--textColor);\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__NjMd5`,
	"langButton": `footer_langButton__TnGDQ`,
	"lang": `footer_lang__FMjCi`,
	"active": `footer_active__k3EW8`,
	"link": `footer_link__DsQ78`
};
export default ___CSS_LOADER_EXPORT___;
